import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestAddchgsGetRes } from "./abst/DtoRequestAddchgsGetRes";

export class DtoRequestAddchgsGetResImple extends DtoRequestAddchgsGetRes {
  public request = new EntityRequest();

  public pager = new DtoApiPager();
}
